export default "__VITE_ASSET__BCjegkVp__"